import { DataService } from './../../services/data.service';
import { ImageService } from './image.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import { StripSpecialCharsPipe } from '../strip-special-chars/strip-special-chars.pipe';
import { KlaLogo, Image } from '../services/kla.data.models';
import { KlaDataService } from '../services/kla.data.service';
import { KlaHttpService } from '../services/kla.http.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'kla-social-media-buttons',
  templateUrl: './social-media-buttons.component.html',
  styleUrls: ['./social-media-buttons.component.scss'],
  standalone: true,
  imports: [ CommonModule ]
})
export class SocialMediaButtonsComponent implements OnInit {
  logoImagePath: any;
  isShown: boolean = false;

  @Input() set linkFragment(value) {
    this._linkFragment = value;
  }

  @Input() image;

   componentImageUrl: any;
  shortUrl: any;

  private _linkFragment;

  logo: KlaLogo;

  constructor(
    private route: Router,
    private dataService: KlaDataService,
    private httpService: KlaHttpService,
    private imageService: ImageService,
    private router: ActivatedRoute
  ) {

    this.router.queryParams.subscribe((param) => {
      let fragment = param?.component;
      if(fragment && fragment != null && fragment != undefined) {
        document.getElementById(fragment).scrollIntoView({
          block: 'center'
        });
      }
    })

   }

   get currentUrl() {
    return window.location.href.split('#')[0];
  }

   toggleDropdown() {
    this.isShown = true;
   }

  ngOnInit(): void {

    this.logo = DataService.getData().logo;

    const imageConfig: Image = {
      id: this.logo.image,
      width: 500,
      height: +this.logo.height,
      crop_config: this.logo.crop_config
    };

    if (this.logo.image != null && this.logo.image) {
      this.logoImagePath = this.httpService.getCroppedImagePath(imageConfig);
    } else {
      this.logoImagePath = '';
    }
    if(this.imageService.mainImgPath.value != null && this.imageService.mainImgPath.value) {
      this.componentImageUrl = this.imageService.mainImgPath.value;
    } if(this.imageService.mainImgPath.value == null && !this.imageService.mainImgPath.value) {
      this.componentImageUrl = this.logoImagePath;
    }
  }

  getFragmentLink() {
    return this.currentUrl + '#' + StripSpecialCharsPipe.strip(this._linkFragment);;
  }

  copyToClipboard() {
    const fragmentLink = this.getFragmentLink();

    // Create a temporary input element
    const tempInput = document.createElement('input');
    tempInput.value = fragmentLink;
    document.body.appendChild(tempInput);

    // Copy the text from the input field
    tempInput.select();
    tempInput.setSelectionRange(0, 99999); // For mobile devices

    try {
      document.execCommand('copy');
    } catch (err) {
      console.error('Failed to copy link:', err);
    }

    // Remove the temporary input element
    document.body.removeChild(tempInput);
  }

  getFaceBookURL() {
    window.open('http://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.currentUrl + '#' + StripSpecialCharsPipe.strip(this._linkFragment)), 'sharer', 'top=' + '200' + ',left=' + '200' + ',toolbar=0,status=0,width='+'500'+',height='+'500');
  }

  getTwitterURL(){
   return `https://twitter.com/intent/tweet?source=tweetbutton&text=${this._linkFragment}&url=${encodeURIComponent(this.currentUrl + '#' + StripSpecialCharsPipe.strip(this._linkFragment))}`
 }

 getLinkedInURL() {
  window.open('http://www.linkedin.com/shareArticle?url=' + encodeURIComponent(this.currentUrl + '?component=' + StripSpecialCharsPipe.strip(this._linkFragment)), 'sharer', 'top=' + '200' + ',left=' + '200' + ',toolbar=0,status=0,width='+'500'+',height='+'500');
 }

 getPinterestURL() {
  return `https://www.pinterest.com/pin/create/button?url=${encodeURIComponent(this.currentUrl + '#' +StripSpecialCharsPipe.strip(this._linkFragment)) + '&media=' + encodeURIComponent(this.componentImageUrl)}`
 }

 setIconColor() {
  let color = {
    'fill': `${'#fff'}`
  }
  return color;
 }

}
